import { api } from './api'
import type { FlowDeliverable, FlowMeta, FlowTemplateDeliverableSpec, FlowTemplateSummary } from '../types/flow'

export async function listFlowTemplates(): Promise<FlowTemplateSummary[]> {
  const wid = localStorage.getItem('current_workspace_id')
  const params = wid ? { workspace_id: wid } : {}
  const { data } = await api.get('/flow-templates', { params })
  return data?.items ?? []
}

export async function getFlowTemplate(templateId: number) {
  const wid = localStorage.getItem('current_workspace_id')
  const params = wid ? { workspace_id: wid } : {}
  const { data } = await api.get(`/flow-templates/${templateId}`, { params })
  return data as {
    id: number
    slug: string
    name: string
    schema: {
      deliverables?: FlowTemplateDeliverableSpec[]
      deliverables_sequence?: string[]
    }
  }
}

export async function getFlowSessionStatus(
  conversationId: number,
  flowSessionToken?: string | null,
): Promise<{
  guided_flow: FlowMeta
  flow_session_token?: string | null
  flow_template_id: number
} | null> {
  const headers: Record<string, string> = {}
  if (flowSessionToken) {
    headers['X-Flow-Session-Token'] = flowSessionToken
  }
  try {
    const { data } = await api.get(`/flow-sessions/${conversationId}`, { headers })
    return data
  } catch {
    return null
  }
}

export async function listFlowDeliverables(
  conversationId: number,
  flowSessionToken?: string | null,
): Promise<FlowDeliverable[]> {
  const headers: Record<string, string> = {}
  if (flowSessionToken) {
    headers['X-Flow-Session-Token'] = flowSessionToken
  }
  const { data } = await api.get(`/flow-sessions/${conversationId}/deliverables`, { headers })
  return data?.items ?? []
}

export function saveFlowSessionToken(conversationId: number, token: string) {
  try {
    localStorage.setItem(`flow_session_token_${conversationId}`, token)
  } catch {
    /* ignore */
  }
}

export function loadFlowSessionToken(conversationId: number): string | null {
  try {
    return localStorage.getItem(`flow_session_token_${conversationId}`)
  } catch {
    return null
  }
}

export function clearFlowSessionToken(conversationId: number) {
  try {
    localStorage.removeItem(`flow_session_token_${conversationId}`)
  } catch {
    /* ignore */
  }
}
